import { LengthOfService } from 'components/employee-analytics/analytic-item/LengthOfService'
import { useState } from 'react'
import { API_EMPLOYEE_ANALYTICS } from 'services/apiEmployeeAnalytics'
import { useFetch } from 'services/useFetch'

const INITIAL_FILTER = {
    employee_type: null,
    company_ids: [],
    department_ids: [],
    division_ids: [],
    sub_division_ids: [],
}

const LengthOfServiceContainer = () => {
    const { data: lengthOfServiceData, fetching: getLengthOfService, isLoading } = useFetch(
        API_EMPLOYEE_ANALYTICS.LENGTH_OF_SERVICE,
        INITIAL_FILTER,
        { isFetching: true },
    )
    const [filter, setFilter] = useState(INITIAL_FILTER)

    const onSubmitFilter = (newFilter) => {
        if (JSON.stringify(filter) !== JSON.stringify(newFilter)) {
            setFilter(newFilter)
            getLengthOfService(newFilter)
        }
    }

    const props = {
        data: lengthOfServiceData?.data || [],
        isLoading,
        filter,
        onSubmitFilter,
    }

    return <LengthOfService {...props} />
}

export default LengthOfServiceContainer
